import { DateBlock } from "./DateBlock";
import { cn } from "./lib/cn";

export interface DeadlineRowProps {
  /** `YYYY-AA-GG` — bkz. `DateBlock`. */
  date: string;
  title: string;
  subtitle?: string;
  /** "5 gün kaldı", "Bugün" gibi hazır metin — HESAPLAMA burada yapılmaz. */
  remainingLabel: string;
  /**
   * Kalan sürenin rengi. ⚠ Kararı ÇAĞIRAN verir (kart: uyarılar hukuki hüküm değil,
   * CLOS-182) — bileşen "7 günden az mı" gibi bir eşik kuralı İÇERMEZ, o kural bir gün
   * ürün kararı değişirse burada değil çağıranda değişmeli.
   */
  tone?: "default" | "warning" | "danger";
  className?: string;
}

const toneClasses: Record<NonNullable<DeadlineRowProps["tone"]>, string> = {
  default: "text-fg-muted",
  warning: "text-warning",
  danger: "text-danger",
};

/** Kritik tarih satırı — mockup Ana Sayfa "Yaklaşan Kritik Tarihler" (12 AĞU). */
export function DeadlineRow({
  date,
  title,
  subtitle,
  remainingLabel,
  tone = "default",
  className,
}: DeadlineRowProps) {
  return (
    <div
      className={cn(
        "flex h-16 items-center gap-3 rounded-lg border border-border-subtle px-3.5 transition-colors hover:bg-muted",
        className,
      )}
    >
      <DateBlock date={date} />
      <div className="min-w-0 flex-1">
        <span className="block truncate text-sm font-semibold text-fg-strong">{title}</span>
        {subtitle ? (
          <span className="block truncate text-[13px] text-fg-muted">{subtitle}</span>
        ) : null}
      </div>
      <span className={cn("shrink-0 text-xs font-medium", toneClasses[tone])}>
        {remainingLabel}
      </span>
    </div>
  );
}
